<template>
  <Modal :title="t(title)" :cancel="cancel" :actions="{'Confirm': doConfirm}" :action-moods="{'Confirm':'primary'}">
    <div class="prompt-modal">
      <p v-if="message">{{t(message)}}</p>
      <Input :placeholder="placeholder" :value="inputValue" @input="v => inputValue = v" />
    </div>
  </Modal>
</template>

<script>
import Modal from "@/components/ui/layout/Modal";
import Input from "@/components/ui/form/Input";
import t from '@/lib/Locale'

export default {
  name: "PromptModal",
  components: {Modal, Input},
  props: {
    title: {type: String, default: "Enter a value"},
    message: {type: String, default: ""},
    placeholder: {type: String, default: ""},
    defaultValue: {type: String, default: ""},
    confirm: {type: Function},
    cancel: {type: Function},
  },
  data() {
    return {
      inputValue: this.defaultValue
    }
  },
  methods: {
    t,
    doConfirm() {
      if (this.inputValue && this.inputValue.trim()) {
        this.confirm(this.inputValue.trim())
      }
    }
  }
}
</script>
